import { put, takeEvery } from "redux-saga/effects";
import {
  SETADDRESS
} from "../actions";

function* AddMessage(action) {
  yield put({ type: SETADDRESS, value: action.value });
  yield new Promise((res) => {
    setTimeout(() => {
      res();
    }, 1000);
  });
  yield put({ type: SETADDRESS, value: action.value.index });
}

export default function* rootSaga() {
  yield takeEvery(SETADDRESS, AddMessage);
}


// function* runRequestSuggest(text) {
//   const { data, error } = yield call(API.suggest, text);
//   if (data && !error) {
//     yield put(successSuggest({ data }));
//   } else {
//     yield put(failureSuggest({ error }));
//   }
// }

// function createLazily(msec = 1000) {
//   let ongoing;
//   return function* (task, ...args) {
//     if (ongoing && ongoing.isRunning()) {
//       ongoing.cancel();
//     }
//     ongoing = yield fork(function* () {
//       yield call(delay, msec);
//       yield fork(task, ...args);
//     });
//   }
// }

// function* handleRequestSuggest() {
//   const lazily = createLazily();
//   while (true) {
//     const { payload } = yield take(REQUEST_SUGGEST);
//     yield fork(lazily, runRequestSuggest, payload);
//   }
// }

// export default function* rootSaga() {
//   yield takeEvery(BEFOREADDMESSAGE, AddMessage);
// }
// export default function* rootSaga() {
//   yield fork(handleRequestSuggest);
// }
// import { all, takeEvery, fork } from 'redux-saga/effects';
// import { BEFOREADDMESSAGE } from '../actions'; // 确保正确引入动作类型
// import AddMessage from './path/to/AddMessage'; // 确保引入 AddMessage 函数
// import handleRequestSuggest from './path/to/handleRequestSuggest'; // 确保引入此函数

// export default function* rootSaga() {
//   yield all([
//     takeEvery(BEFOREADDMESSAGE, AddMessage), // 监听 BEFOREADDMESSAGE 动作
//     // fork(handleRequestSuggest), // 启动后台任务 handleRequestSuggest
//   ]);
// }
